const en = require('./en.json');

export default {
  'en-AU': en,
  'en-NZ': en,
};
